// extracted by mini-css-extract-plugin
module.exports = {"base":"BreadcrumbBar_base__3mM_H","link":"BreadcrumbBar_link__nSvLw"};